export default __webpack_public_path__ + "static/media/korpom.c497b22b.gif";